import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import isPlainObject from 'is-plain-object';
import { DEFAULT_VIEW_KEY } from '../constants';
import Column from '../models/Column';
import Record from '../models/Record';
import Selection from '../models/Selection';
import Views from '../models/Views';
import Field from '../models/Field';
import Value from '../models/Value';
import getDefaultPosition from './getDefaultPosition';
var uuid = 0;
var creators = {
  columns: function columns(tagName, attributes, _columns) {
    var selectedColumns = [];
    var previousPosition = 0;
    return {
      columns: _columns.reduce(function (memo, column) {
        column.key = column.key || (uuid++).toString();
        column.position = column.position || getDefaultPosition(previousPosition);
        previousPosition = column.position;
        if (column.isSelected) selectedColumns.push(column.key);
        memo[column.key] = column;
        return memo;
      }, {}),
      selectedColumns: selectedColumns
    };
  },
  column: function column(tagName, attributes, children) {
    var data = {};
    var options = children.filter(function (child) {
      return child.option;
    }).map(function (child) {
      return child.option;
    });

    if (options.length > 0) {
      data.options = options.reduce(function (acc, option) {
        option.key = option.key || (uuid++).toString();
        acc[option.key] = option;
        return acc;
      }, {});
    }

    return Column.create(_objectSpread({
      data: data
    }, attributes));
  },
  records: function records(tagName, attributes, _records) {
    var selection = Selection.create();
    var previousPosition = 0;
    return {
      records: _records.reduce(function (memo, _ref) {
        var activeField = _ref.activeField,
            record = _objectWithoutProperties(_ref, ["activeField"]);

        record.position = record.position || getDefaultPosition(previousPosition);
        previousPosition = record.position;

        if (activeField) {
          selection.activeKey = "".concat(record.key, "_").concat(activeField);
          selection.selectedKeys.push(selection.activeKey);
        }

        memo[record.key] = record;
        return memo;
      }, {}),
      selection: selection
    };
  },
  record: function record(tagName, attributes, fields) {
    var activeField;
    return Record.create(_objectSpread({
      key: (uuid++).toString()
    }, attributes, {
      fields: fields.reduce(function (memo, _ref2) {
        var isActive = _ref2.isActive,
            field = _objectWithoutProperties(_ref2, ["isActive"]);

        field.key = field.key || (uuid++).toString();
        field.columnKey = field.columnKey || (uuid++).toString();

        if (isActive) {
          activeField = field.columnKey;
        }

        memo[field.columnKey] = field;
        return memo;
      }, {}),
      activeField: activeField
    }));
  },
  database: function database(tagName, attributes, children) {
    var _ref3 = children.find(function (child) {
      return !!child.columns;
    }) || {},
        columns = _ref3.columns;

    var _ref4 = children.find(function (child) {
      return !!child.records;
    }) || {},
        records = _ref4.records,
        recordsSelection = _ref4.selection;

    var _ref5 = children.find(function (child) {
      return !!child.views;
    }) || {},
        views = _ref5.views;

    var _ref6 = children.find(function (child) {
      return !!child.selection;
    }) || recordsSelection || {},
        selection = _ref6.selection;

    return Value.create({
      attributes: attributes,
      columns: columns,
      records: records,
      selection: selection,
      views: _objectSpread(_defineProperty({}, DEFAULT_VIEW_KEY, Views.create({
        key: 'default'
      })), views)
    });
  },
  selection: function selection(tagName, attributes, children) {
    return {
      selection: Selection.create(attributes)
    };
  },
  field: function field(tagName, attributes, children) {
    var data = attributes;

    if (children.length === 1) {
      data.text = children[0];
    }

    return Field.create(_objectSpread({
      columnKey: tagName,
      data: data
    }, attributes));
  },
  option: function option(tagName, attributes, children) {
    var label = children.length ? children.join('') : attributes.key;
    return {
      option: _objectSpread({}, attributes, {
        label: label
      })
    };
  }
};
export default function hyperscript(tagName, attributes) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  var creator = creators[tagName] || creators.field;

  if (attributes == null) {
    attributes = {};
  }

  if (!isPlainObject(attributes)) {
    children = [attributes].concat(children);
    attributes = {};
  }

  children = children.filter(function (child) {
    return Boolean(child);
  }).reduce(function (memo, child) {
    return memo.concat(child);
  }, []);
  var ret = creator(tagName, attributes, children);
  return ret;
}